export default {
  selectedFilter: (state) => state.selectedFilter,
  hasMoreContacts: (state) => state.hasMoreContacts,
  hasMoreCommunications: (state) => state.hasMoreCommunications,
  agentStatuses: (state) => state.agentStatuses
}
